import { css } from 'aphrodite';
import { Toggle } from '../../../../components/Toggle';
import { InfoIcon } from '../../../../components/svgs/icons/InfoIcon';
import { brandSecondary } from '../../../../styles/colors';
import { bs } from '../../../../styles/styles';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../Tooltip';

export function EmailDuplicateContactSendToggle({
	isSelected,
	onChange,
}: {
	isSelected: boolean;
	onChange: (checked: boolean) => void;
}) {
	return (
		<div className={css(bs.flex, bs.itemsCenter, bs.gap1)}>
			<Toggle
				id='dontSendMultipleEmailsToSameAddressToggle'
				isOn={isSelected}
				text="Don't send multiple emails to the same address"
				textStyles={[bs.textXs, bs.textTitles]}
				uncheckedColor='#ccc'
				onToggleCheckChanged={onChange}
			/>
			<Tooltip>
				<TooltipTrigger>
					<InfoIcon fillColor={brandSecondary} className={css(bs.block, bs.h4, bs.w4)} />
				</TooltipTrigger>
				<TooltipContent styles={[]}>
					Some recipients share the same email address. You can choose to send a copy to each.
				</TooltipContent>
			</Tooltip>
		</div>
	);
}
